import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, FormProvider } from 'react-hook-form'

import axios from '../../dataClient/dataClient'
import { SpaceBetweenRowContainer, FlexEndContainer, FlexEndButtonErrorContainer, MedBGContainer, Form } from '../styles/Containers'
import { ErrorMessage } from '../common/UserMessage'
import Button, { SecondaryButton } from '../common/Button'
import BodyText, { PlaceholderSpan } from '../styles/Text'
import FormInput from '../inputFields/FormInput'

const responseNoteInfoText = 'When your response is sent to the requestor, it will include the following message:'

const schema = yup.object().shape({
  responseNote: yup.string()
})

function ResponseNote({ pirId, responseNote = '', onUpdateNote = () => {} }) {
  const [isEditing, setIsEditing] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [lastSavedNote, setLastSavedNote] = useState(responseNote)

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      responseNote: lastSavedNote
    }
  })
  const { reset, handleSubmit } = methods

  const toggleEdit = () => setIsEditing(isEditing => !isEditing)

  const onError = (errors, e) => console.error('Error', errors, e)

  function onSubmit(payload) {
    const updatedNote = payload.responseNote
    setLoading(true)
    setError(false)

    axios
      .patch(`/pir/${pirId}`, { responseNote: updatedNote }, { headers: { 'Content-Type': 'application/json' } })
      .then(({ data }) => {
        setLastSavedNote(data.data.responseNote)
        onUpdateNote(data.data.responseNote)
        setIsEditing(false)
        setLoading(false)
      })
      .catch(e => {
        setError(true)
        console.error('Failed to update the response note', e)
        setLoading(false)
      })
  }

  function onCancel() {
    reset({
      responseNote: lastSavedNote
    })
    setIsEditing(false)
    setError(false)
  }

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(onSubmit, onError)} gap="10px">
        <SpaceBetweenRowContainer>
          <BodyText>{responseNoteInfoText}</BodyText>
          {!isEditing ? (
            <Button onClick={toggleEdit}>Edit</Button>
          ) : (
            <FlexEndButtonErrorContainer>
              <FlexEndContainer>
                <SecondaryButton onClick={onCancel} disabled={loading}>
                  Cancel
                </SecondaryButton>
                <Button type="submit" loading={loading}>
                  Save
                </Button>
              </FlexEndContainer>
              {error && <ErrorMessage>Error updating response note. Please try again.</ErrorMessage>}
            </FlexEndButtonErrorContainer>
          )}
        </SpaceBetweenRowContainer>
        {isEditing ? (
          <FormInput id="responseNote" label="" multiline disabled={loading} />
        ) : (
          <MedBGContainer padding="15px 30px">
            <BodyText>{lastSavedNote ? lastSavedNote : <PlaceholderSpan>Add your message by editing</PlaceholderSpan>}</BodyText>
          </MedBGContainer>
        )}
      </Form>
    </FormProvider>
  )
}

ResponseNote.propTypes = {
  pirId: PropTypes.string.isRequired,
  responseNote: PropTypes.string,
  onUpdateNote: PropTypes.func
}

export default ResponseNote
